import { render, staticRenderFns } from "./CaseDetail.vue?vue&type=template&id=389c5224&"
import script from "./CaseDetail.vue?vue&type=script&lang=js&"
export * from "./CaseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports